module.exports = __webpack_public_path__ + "img/file-invoice-dollar-duotone.c906989d.svg";